import { render, staticRenderFns } from "./addLessonPlanModelOnNewAttMarking.vue?vue&type=template&id=5d1977a8"
import script from "./addLessonPlanModelOnNewAttMarking.vue?vue&type=script&lang=js"
export * from "./addLessonPlanModelOnNewAttMarking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports